import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DemoService } from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';

// 
// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor, Query, ReturnOption, DataUtil } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import { IFilter } from '@syncfusion/ej2-angular-grids';
import {
  GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
  RowDataBoundEventArgs
} from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
// import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
// import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Observable } from 'rxjs';

import { BsModalService } from 'ngx-bootstrap/modal';
import { SubjectServiceOutcomeTemplate } from 'src/app/shared/models/subjectServiceOutcomeTemplate.model';
import { SubjectService } from 'src/app/api/subjectService';
import { DomSanitizer } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import { HotToastService } from '@ngneat/hot-toast';
import { buildResolutionOutcomeDisplay } from 'src/app/shared/functions/subject-service-resolution-outcome-display';


@Component({
  selector: 'app-job-subject-attempts-grid',
  templateUrl: './job-subject-attempts-grid.component.html',
  styleUrls: ['./job-subject-attempts-grid.component.css']
})
export class JobSubjectAttemptsGridComponent implements OnInit {

  @Input() job_id: number;
  @Input() brand_id?: number;
  @Input() job_status_code?: any;
  @Input() assigned_agent?: any; // single agent brand_id lookup

  // passed Values.
  // setup as observable?
  @Input() item_id?; // impliments on changes. // Base set to Job_ID
  @Input() item_data?; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id

  @Input() item_user_level_id?= '5'; // default to agent just in case
  @Input() item_brand_type_id?= null;
  @Input() item_brand_id?= null;
  @Input() item_subject_id?= null;
  @Input() item_subject_number?= '';

  @Input() show_buttons?= 'no'; // yes | no
  @Input() item_title?= '';
  @Input() widget_size?= ''; // side | abstract | full


  @Input() file_number?: any; // subject file number
  @Input() subject_number?: any; // subject file number
  @Input() brand_type_id?: any; // subject file number
  @Input() reference_number?; any;
  @Input() subject_id: any;

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 };
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[];

  @ViewChild('grid') grid: GridComponent;

  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  all_router_details: string;
  subject_service: any;
  subject_services: any = [];
  modalRef: any;
  subject_services_filtered: any;
  subject_services_filtered_attendance: any;
  subject_services_filtered_not_yet_rated: any;
  subject_services_data: any;
  subject_services_data_table: any;
  allAgentRecipients: any[];
  assignedAgentsList2: Object;
  brand_invoice_id: any;
  brand_report_id: any;
  job: Object;
  subjects: Object;

  model: SubjectService;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  job_status_code_current: any;
  resolution_outcomes: any[] = [];
  resolution_outcome_types: any[] = [];

  constructor(private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
    public datepipe: DatePipe, public gfunc: GlobalFunctionsService,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private clipboard: Clipboard, // ciipboard
    public toastr: HotToastService,
    ) {


    // login vars
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  this.sessionUserLevel = this.gfunc.currentUserVAR.access_level;

      // need to add this as routes does not work globally
    this.all_router_details = this.router.url;
     this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  }


  ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
     this.subject_id = changes.item_id.currentValue;

    //  this.subject_services = new SubjectService();
    //  this.subject_service = new SubjectService();
     this.getSubjectServices(this.item_id);
     this.getSubjectAgentBrandsAssigned_comms(this.item_id); // then removes the others on button clicks.
     this.getJobSubject(this.item_id);
    //  // Load different quieries based on if agent associated
    //  if (this.gfunc.current_base_route === '/agent/jobs/view-job') {
    //   // only show the subjects if the agent is associated quiery.
    //   this.getAssignedAgentsJobsSubjectsGrid(this.job_id, this.brand_id, this.job_status_code, this.assigned_agent);
    // } else {
    //   // Standard and works for all users except agents
    //   this.getJobsTableDataSubjects(this.job_id);
    // }




    // Grid Options
    // this.toolbarOptions = ['ExcelExport', 'Search'];
    this.toolbarOptions = []; // none
    this.initialPage = { pageSize: 5 };
    this.filterOptions = {
      type: 'Menu'
    };
    // this.groupOptions = { columns: ['subject_attempt_type_id'] }; // sets auto grouping for the grid
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };
    this.sortOptions = { columns: [{ field: 'date_created', direction: 'Descending' }]};  
    


    // end date filter options
    // End Grid Options
    }

    }


  ngOnInit() {
    this.getResolutionOutcomeDisplayData();
  }



  // Setup the SyncFusion GRID


  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
    }
  }






  getSubjectServiceAll(subject_id) {
    this._demoService.getSubjectServiceAll(subject_id).subscribe(
      data => { this.subject_service = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
      let res = data[0]; 
    
      /* 
       this.getServiceMethod(res.subject_service_method_id);
       this.getSubjectRelationship(res.fellow_occupants_relationship);
       this.getExactServiceMethod(res.exact_service_method);
       this.getSubjectServiceOutcome(res.subject_service_outcome_id);
       this.getBrandById(res.who_service); // get agent/brand that served
        this.getSubjectLocationStatus(res.subject_location_status_id);
        this.getSubjectLocationStatusFound(res.subject_location_status_found_id);
       */
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }



    getSubjectServices(subject_id) {
      this._demoService.getSubjectServices(subject_id).subscribe(
        data => { 
          // this.subject_services = data;

// if an agent filter the attempts grid. (only for main grid the rest of the calls mormal)
this.subject_services_data = data;
// console.log('data; ', JSON.stringify(data));
        // this.notes = data;
this.subject_services_data_table = this.subject_services_data.slice(0, 10);

// new sysetm to filter only notes for agents views.
if (this.gfunc.sessionUserLevel == 5) {
let newArr = Object(data).filter((sbi)=>(sbi.who_service == this.gfunc.sessionBrandId)); // User this if filter is needed.
 // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
this.subject_services = DataUtil.parse.parseJson(newArr);
// this.grid.refresh(); // was causing errors in page

} else {
  // this.subject_services_data = data;
  this.subject_services = data;
  // this.grid.refresh(); // was causing javascript errors on page?
}

         // console.log("Done loadng USER");
         // console.log(this.users);
         let res = data[0];
        
         // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
         // this.getUsersById(res.who_attended);

// :: For the side widget data: filter only served, latest 1
let uniqueArray = this.subject_services.filter((v,i,a)=>a.findIndex(t=>(t.subject_service_outcome_id === '1'))===i);
let uniqueArray2 = this.subject_services.filter((v,i,a)=>a.findIndex(t=>(t.subject_service_outcome_id !== '1'))===i);


let attempts_not_rated =  Object(data).filter((sbi)=>(sbi.subject_attempt_type_id == 2 && sbi.subject_service_resolution_outcome_id == 0 ));


this.subject_services_filtered = uniqueArray; // getting the first record only
this.subject_services_filtered_attendance = uniqueArray2; // getting the first record only

this.subject_services_filtered_not_yet_rated = DataUtil.parse.parseJson(attempts_not_rated);
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }



      deleteSubjectService(subject_service_id) {
        if (confirm('Are you sure you want to delete this Service Information? ')) {
          this._demoService.deleteSubjectService(subject_service_id).subscribe(
             data => {
             // this.getSubjectServices(this.subject_id);
              this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
               return true;
             },
             error => {
               console.error('Error deleting Attendence!');
              return console.log(error);
             }
          );
      }
      }







  jobLink(job_id) {
    this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  }

  jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }

  subjectEdit(subject_id) {
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  }


  refreshGrid() { // refresh the databutton
    // this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);

    // if (this.gfunc.current_base_route === '/agent/jobs/view-job') {
    //   // only show the subjects if the agent is associated quiery.
    //   this.getAssignedAgentsJobsSubjectsGrid(this.job_id, this.brand_id, this.job_status_code, this.assigned_agent);
    // } else {
    //   // Standard and works for all users except agents
    //   this.getJobsTableDataSubjects(this.job_id);
    // }
    this.getSubjectServices(this.subject_id);
    this.grid.refresh();
  };


  getJobsTableDataSubjects(job_id) {
    this._demoService.getJobsTableDataSubjects(job_id).subscribe(
      data => {
        this.subjects_urgent = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }

  getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent) {
    this._demoService.getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent).subscribe(
      data => {
        this.subjects_urgent = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {

      //  this.grid.showSpinner();

      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
      //  console.log(args.data.items);



      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        // console.log(pdfdata.results);

        // this.search_results = pdfdata.records; // need this if a grouping is set.
        /*   this.search_results = pdfdata;
          this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
          this.toastr.success( "Press Start To Process Que");  */
        // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
    }

    //  this.grid.hideSpinner();

  };


















  getBrandJobsTableData(brand_id) {
    this._demoService.getBrandJobsTableData(brand_id).subscribe(
      data => {
        this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }

  getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
    this._demoService.getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent).subscribe(
      data => {
        this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  // End Grid Items and Setup


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};




createServiceReportDocx(model) {
  model.doc_id = 13;
  model.subject_com_type_id = 3;
  model.subject_id = this.subject_id;
  // model.brand_type_id = 3; // for agent
  model.brand_type_id = 2; // for client /// NO THIS IS FOR AGENT!!!!!!!!!!!!
// need to add the assiged to agent array in the process here? in on the function?
// do it here so that I can set the exact agent ie, from the servers or who it is especially for.. like create a doc merge model.
if (model.subject_com_type_id == 3) {
      // set the agent permissions
           // secuirty agents assign_to_agents
       // set the agent permissions

      // I then need to remove others that are not this subject to keep to specific agent to sent file in array
      // tslint:disable-next-line:max-line-length
      this.RemoveElementOthersFromAllAgentRecipients(model.who_service); // has to be the selected agent id? // the agent who made the attendance. / service
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
      console.log('model.assinged_to_agents: ', model.assigned_to_agents);
}

// See Global Function to See Vars
 this.gfunc.createDocumentButtonTest(model); // deactivated for testing must be active to create document.
}


createServiceReportDocxAndSend(model) {
  model.doc_id = 13;
  model.subject_com_type_id = 3;
// See Global Function to See Vars
// TODO below needs to accommodate if sending to an agent as well.
// :: Extra Vars to Establish the send.
model.brand_type_id = 2; // client 2 agent 3 (A service report goes to client.)

model.brand_report_id = this.brand_report_id; // current subject job details
model.brand_invoice_id = this.brand_invoice_id; // current subject job details
model.brand_work_order_id = null;
model.send_to_invoice = null; // 1 or 0
model.send_to_report = 1; // 1 or 0
model.send_to_logins = 0; // 1 or 0
model.send_to_report_user = 0; // 1 or 0 // TODO not yet datbased API or coded into the system process
model.additional_message = ' ' + this.today;
model.allAttachments = [];

if (model.subject_com_type_id == 3) {
  // set the agent permissions
       // secuirty agents assign_to_agents
  // I then need to remove others that are not this subject to keep to specific agent to sent file in array
  // tslint:disable-next-line:max-line-length
  this.RemoveElementOthersFromAllAgentRecipients(model.who_service); // has to be the selected agent id? // the agent who made the attendance. / service
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
  // console.log('model.assinged_to_agents: ', model.assigned_to_agents);
}

  // :: Now create the doc and email through the communication template sysstem as a global function
  this.gfunc.createDocumentButtonAndSend(model);

  /// MEEED TO ADD NOTE HERE>>>>

  // this.toastr.success( 'Creating and Sending Documentation');

}


createAffidavitTestDocxAndSend(model) {
  model.doc_id = 66;
  model.subject_com_type_id = 4; // 4 Affidavits
  model.job_type_id = 1; // 1  Process Serviing,
  model.job_type_location_id =  3; // 3 QLD
  model.job_type_court_id = 8; // Civil
  model.job_type_document_type_id = 44; // 44 notice of default
  model.job_type_affidavit_type_id = 91; // 91 attemp of services

// See Global Function to See Vars
// TODO below needs to accommodate if sending to an agent as well.
// :: Extra Vars to Establish the send.
model.brand_type_id = 3; // client 2 agent 3
model.brand_report_id = 97; // current subject job details
model.brand_invoice_id = 97; // current subject job details
model.brand_work_order_id = null;
model.send_to_invoice = null; // 1 or 0
model.send_to_report = 0; // 1 or 0
model.send_to_logins = 0; // 1 or 0
model.send_to_report_user = 0; // 1 or 0 // TODO not yet datbased API or coded into the system process
model.additional_message = " " + this.today;
model.allAttachments = [];

// additions for new subject assigned_to subjects array\
// or do I set this in the global functions to be more universial 
// model.assigned_to_agents = JSON.stringify(this.allRecipients);
console.log('model.assigned_to_agents: ', model.assigned_to_agents);

  // :: Now create the doc and email through the communication template sysstem as a global function
  this.gfunc.createDocumentButtonAndSend(model);

}


createAttemptedServiceReportDocx(model) {
  model.doc_id = 14;
  model.subject_com_type_id = 3;
// See Global Function to See Vars
model.subject_id = this.subject_id;
model.brand_type_id = 2; // for client


if (model.subject_com_type_id == 3) {
  // set the agent permissions
       // secuirty agents assign_to_agents
  // I then need to remove others that are not this subject to keep to specific agent to sent file in array
  // tslint:disable-next-line:max-line-length
  this.RemoveElementOthersFromAllAgentRecipients(model.who_service); // has to be the selected agent id? // the agent who made the attendance. / service
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
  console.log('model.assinged_to_agents: ', model.assigned_to_agents);
}

  this.gfunc.createDocumentButtonTest(model);
}


createAttemptedServiceReportDocxAndSend(model) {
  model.doc_id = 14;
  model.subject_com_type_id = 3;
  model.subject_id = this.subject_id;
  model.brand_type_id = 2; // for client
// See Global Function to See Vars

console.log('who service attempt: ', model.who_service);

if (model.subject_com_type_id == 3) {
  // set the agent permissions
       // secuirty agents assign_to_agents
  // I then need to remove others that are not this subject to keep to specific agent to sent file in array
  // tslint:disable-next-line:max-line-length
  this.RemoveElementOthersFromAllAgentRecipients(model.who_service); // has to be the selected agent id? // the agent who made the attendance. / service
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
  console.log('model.assinged_to_agents: ', model.assigned_to_agents);
}
 
// TODO below needs to accommodate if sending to an agent as well.
// :: Extra Vars to Establish the send.
// model.brand_type_id = 2; // client 2 agent 3
model.brand_report_id = this.brand_report_id; // current subject job details
model.brand_invoice_id = this.brand_invoice_id; // current subject job details
model.brand_work_order_id = null;
model.send_to_invoice = null; // 1 or 0
model.send_to_report = 1; // 1 or 0
model.send_to_logins = 0; // 1 or 0
model.send_to_report_user = 0; // 1 or 0 // TODO not yet datbased API or coded into the system process
model.additional_message = "Automated Email Via button Press " + this.today;
model.allAttachments = [];

console.log('assigneed to agents attempt: ', model.assigned_to_agents);
  // :: Now create the doc and email through the communication template sysstem as a global function
 this.gfunc.createDocumentButtonAndSend(model);
}





getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.subjects = data;
      let res = data[0];
      // this.model.subject_number = res.subject_number;
      // this.model.job_reference_number = res.job_reference_number;
      // this.model.file_number = res.file_number;
      // this.model.reference_number = res.reference_number;
      // this.model.brand_id = res.brand_report_id;
this.job_id = res.job_id;
this.getJob(this.job_id);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




 getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
     data => { this.job = data;
      let res = data[0];
      // Need to load the drop downs (only if a process is selected.)
      this.brand_report_id = res.brand_report_id;
      this.brand_invoice_id = res.brand_invoice_id;

      this.job_status_code_current = res.job_status_code

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }  


// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_comms(subject_id) {
  this.allAgentRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

// console.log('this.allAgentRecipients: ', JSON.stringify(this.allAgentRecipients));



    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }

 

 RemoveElementFromAllRecipients_comms(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};

RemoveElementOthersFromAllAgentRecipients(key: number) {
  // test! -- load again an then filter and create the array again.
  // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.

  // delay load slightly so I can refresh the allRecpientList first.
  setTimeout(function() {   
}, 2000);
    console.log("Ready to clean array!")

  let array = this.allAgentRecipients;
  // removes all not matching
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
    this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_brand_id !== key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
  // console.log('allAgentRecipients after Removal Others: ', JSON.stringify(this.allAgentRecipients));

// ::@https://stackoverflow.com/questions/5310304/remove-json-element
// let json = this.allRecipients
// let id_key = "recipient_brand_id";
// delete json[id_key]; // Removes json.foo from the dictionary.



};




getTimezoneName() {
  const today = new Date();
  const short = today.toLocaleDateString(undefined);
  const full = today.toLocaleDateString(undefined, { timeZoneName: 'short' });

  // Trying to remove date from the string in a locale-agnostic way
  const shortIndex = full.indexOf(short);
  if (shortIndex >= 0) {
    const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
    
    // by this time `trimmed` should be the timezone's name with some punctuation -
    // trim it from both sides
    return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');

  } else {
    // in some magic case when short representation of date is not present in the long one, just return the long one as a fallback, since it should contain the timezone's name
    return full;
  }
}



  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getResolutionOutcomeDisplayData() {
    this._demoService.getSubjectServiceResolutionOutcomes().subscribe(
      (data: any) => this.resolution_outcomes = data || [],
      err => console.error(err),
    );
    this._demoService.getSubjectServiceResolutionOutcomeTypes().subscribe(
      (data: any) => this.resolution_outcome_types = data || [],
      err => console.error(err),
    );
  }

  getResolutionOutcomeDisplay(model: any) {
    return buildResolutionOutcomeDisplay(model, this.resolution_outcomes, this.resolution_outcome_types);
  }

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }


  copyToClipboardInGrid(id) {
    // const content = document.getElementById('note_content_' + id).innerHTML; // copy all formatting.
    const content = document.getElementById('paragraph_content_' + id).innerText; // wet to copy text and formatting only
    // const content = document.getElementById('note_content_' + id).textContent; // removes all tags and formatting
    
    this.clipboard.copy(content);
    this,this.toastr.info("Note Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboardInGridHTML(id) {
    const content = document.getElementById('paragraph_content_' + id).innerHTML; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    this.clipboard.copy(content);
    this,this.toastr.info("Note Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboard(id) {
    const content = document.getElementById(id).innerHTML; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboardPlainText(id) {
    const content = document.getElementById(id).innerHTML; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    this.clipboard.copy(this.removeTags(content));
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
          // Removes HTML from a sron
          // ::@ https://www.geeksforgeeks.org/how-to-strip-out-html-tags-from-a-string-using-javascript/
          removeTags(str) {
            if ((str===null) || (str===''))
                return false;
            else
                str = str.toString();
                  
            // Regular expression to identify HTML tags in
            // the input string. Replacing the identified
            // HTML tag with a null string.
            return str.replace( /(<([^>]+)>)/ig, '');
        }


}
